module.exports = __webpack_public_path__ + "static/media/RNSSanz-Light.0bddf6a1.otf";